module.exports = __webpack_public_path__ + "img/sankaku_85_blue.39768777.png";